import { ThreePlPartner } from '../../../three-pl-partners/domain/entities/partner-entity';
import { CreateClientRequest } from '../../presentation/redux/types/client-types';
import { APIKey } from '../entities/api-key-entity';
import { Client } from '../entities/client-entity';
import { ClientRepository } from '../repositories/client-repository';

interface ClientUsecase {
  CreateClient(createClientRequest: CreateClientRequest): Promise<Client>;
  GetClients(): Promise<Client[]>;
  GetClient(client_id: string): Promise<Client>;
  GetApiKey(client_id: string): Promise<APIKey>;
  GetSMSAPIKeys(client_id: string): Promise<APIKey>;
  EditClient(client_id: string, name: string): Promise<Client>;
  CreateSuperUser(
    client_id: string,
    firstname: string,
    lastname: string,
    email: string,
    mobile_no: string
  ): Promise<Client>;
  EditSuperUser(
    client_id: string,
    user_id: string,
    firstname: string,
    lastname: string
  ): Promise<Client>;
  UploadLogo(client_id: string, file: any): Promise<Client>;
  GrantServicePermissions(client_id: string): Promise<Client>;
  RevokeServicePermissions(client_id: string): Promise<Client>;
  GrantWalletFeature(client_id: string): Promise<Client>;
  GrantWalletFeatureInitial(
    client_id: string,
    public_key: string,
    private_key: string
  ): Promise<Client>;
  RevokeWalletFeature(client_id: string): Promise<Client>;
  EnableLogo(client_id: string): Promise<Client>;
  DisableLogo(client_id: string): Promise<Client>;
  GrantUseOfThirdPartyApis(client_id: string): Promise<Client>;
  RevokeUseOfThirdPartyApis(client_id: string): Promise<Client>;
  EnableRatings(client_id: string): Promise<Client>;
  DisableRatings(client_id: string): Promise<Client>;
  GetPartners(): Promise<ThreePlPartner[]>;
  AddClientPartner(client_id: string, partners: []): Promise<Client>;
  DeleteClientPartner(client_id: string, partner: object): Promise<Client>;
  GrantGoogleMapsApi(client_id: string, google_maps_api: boolean): Promise<Client>;
  GrantSmsNotifications(client_id: string): Promise<Client>;
  RevokeSmsNotifications(client_id: string): Promise<Client>;
  GrantOtpSmsNotifications(client_id: string): Promise<Client>;
  RevokeOtpSmsNotifications(client_id: string): Promise<Client>;
  GrantEmailNotifications(client_id: string): Promise<Client>;
  RevokeEmailNotifications(client_id: string): Promise<Client>;
  GrantRoutePlanning(client_id: string, route_planning_enabled: boolean): Promise<Client>;
  UpdateSmsProvider(client_id: string, sms_provider: string): Promise<Client>;
  GrantAppChatBot(client_id: string, enabled: boolean): Promise<Client>;
  GrantFlightboardAccess(client_id: string, enabled: boolean): Promise<Client>;
  EditRouteOptimization(client_id: string, return_geometry: boolean): Promise<Client>;
}

export class ClientUsecaseImpl implements ClientUsecase {
  clientRepository: ClientRepository;

  constructor(cr: ClientRepository) {
    this.clientRepository = cr;
  }

  CreateClient(createClientRequest: CreateClientRequest): Promise<Client> {
    return this.clientRepository.CreateClient(createClientRequest);
  }

  GetClients(): Promise<Client[]> {
    return this.clientRepository.GetClients();
  }

  GetClient(client_id: string): Promise<Client> {
    return this.clientRepository.GetClient(client_id);
  }

  GetApiKey(client_id: string): Promise<APIKey> {
    return this.clientRepository.GetApiKey(client_id);
  }

  GetSMSAPIKeys(client_id: string): Promise<APIKey> {
    return this.clientRepository.GetSMSAPIKeys(client_id);
  }

  EditClient(client_id: string, name: string): Promise<Client> {
    return this.clientRepository.EditClient(client_id, name);
  }

  CreateSuperUser(
    client_id: string,
    firstname: string,
    lastname: string,
    email: string,
    mobile_no: string
  ): Promise<Client> {
    return this.clientRepository.CreateSuperUser(client_id, firstname, lastname, email, mobile_no);
  }

  EditSuperUser(
    client_id: string,
    user_id: string,
    firstname: string,
    lastname: string
  ): Promise<Client> {
    return this.clientRepository.EditSuperUser(client_id, user_id, firstname, lastname);
  }

  UploadLogo(client_id: string, file: any): Promise<Client> {
    return this.clientRepository.UploadLogo(client_id, file);
  }
  GrantServicePermissions(client_id: string): Promise<Client> {
    return this.clientRepository.GrantServicePermissions(client_id);
  }
  RevokeServicePermissions(client_id: string): Promise<Client> {
    return this.clientRepository.RevokeServicePermissions(client_id);
  }
  GrantQRTypingPermissions(client_id: string): Promise<Client> {
    return this.clientRepository.GrantQRTypingPermissions(client_id);
  }
  RevokeQRTypingPermissions(client_id: string): Promise<Client> {
    return this.clientRepository.RevokeQRTypingPermissions(client_id);
  }
  GrantSecondaryDriverPermissions(client_id: string): Promise<Client> {
    return this.clientRepository.GrantSecondaryDriverPermissions(client_id);
  }
  RevokeSecondaryDriverPermissions(client_id: string): Promise<Client> {
    return this.clientRepository.RevokeSecondaryDriverPermissions(client_id);
  }
  GrantWalletFeature(client_id: string): Promise<Client> {
    return this.clientRepository.GrantWalletFeature(client_id);
  }
  GrantWalletFeatureInitial(
    client_id: string,
    public_key: string,
    private_key: string
  ): Promise<Client> {
    return this.clientRepository.GrantWalletFeatureInitial(client_id, public_key, private_key);
  }
  RevokeWalletFeature(client_id: string): Promise<Client> {
    return this.clientRepository.RevokeWalletFeature(client_id);
  }

  GrantUseOfThirdPartyApis(client_id: string): Promise<Client> {
    return this.clientRepository.GrantUseOfThirdPartyApis(client_id);
  }
  RevokeUseOfThirdPartyApis(client_id: string): Promise<Client> {
    return this.clientRepository.RevokeUseOfThirdPartyApis(client_id);
  }

  EnableLogo(client_id: string): Promise<Client> {
    return this.clientRepository.EnableLogo(client_id);
  }
  DisableLogo(client_id: string): Promise<Client> {
    return this.clientRepository.DisableLogo(client_id);
  }

  EnableRatings(client_id: string): Promise<Client> {
    return this.clientRepository.EnableRatings(client_id);
  }
  DisableRatings(client_id: string): Promise<Client> {
    return this.clientRepository.DisableRatings(client_id);
  }
  EnableReceiveAllDriverLocation(client_id: string): Promise<Client> {
    return this.clientRepository.EnableReceiveAllDriverLocation(client_id);
  }
  DisableReceiveAllDriverLocation(client_id: string): Promise<Client> {
    return this.clientRepository.DisableReceiveAllDriverLocation(client_id);
  }
  GetPartners(): Promise<ThreePlPartner[]> {
    return this.clientRepository.GetPartners();
  }
  AddClientPartner(client_id: string, partners: []): Promise<Client> {
    return this.clientRepository.AddClientPartner(client_id, partners);
  }
  DeleteClientPartner(client_id: string, partner: object): Promise<Client> {
    return this.clientRepository.DeleteClientPartner(client_id, partner);
  }
  GrantClientCustomPaymentFields(client_id: string, allow_custom_fields: boolean): Promise<Client> {
    return this.clientRepository.GrantClientCustomPaymentFields(client_id, allow_custom_fields);
  }
  GrantGoogleMapsApi(client_id: string, google_maps_api: boolean): Promise<Client> {
    return this.clientRepository.GrantGoogleMapsApi(client_id, google_maps_api);
  }
  GrantSmsNotifications(client_id: string): Promise<Client> {
    return this.clientRepository.GrantSmsNotifications(client_id);
  }
  RevokeSmsNotifications(client_id: string): Promise<Client> {
    return this.clientRepository.RevokeSmsNotifications(client_id);
  }
  GrantOtpSmsNotifications(client_id: string): Promise<Client> {
    return this.clientRepository.GrantOtpSmsNotifications(client_id);
  }
  RevokeOtpSmsNotifications(client_id: string): Promise<Client> {
    return this.clientRepository.RevokeOtpSmsNotifications(client_id);
  }
  GrantEmailNotifications(client_id: string): Promise<Client> {
    return this.clientRepository.GrantEmailNotifications(client_id);
  }
  RevokeEmailNotifications(client_id: string): Promise<Client> {
    return this.clientRepository.RevokeEmailNotifications(client_id);
  }
  GrantRoutePlanning(client_id: string, route_planning_enabled: boolean): Promise<Client> {
    return this.clientRepository.GrantRoutePlanning(client_id, route_planning_enabled);
  }
  GrantCustomerDatabase(client_id: string, customer_details_database: boolean): Promise<Client> {
    return this.clientRepository.GrantCustomerDatabase(client_id, customer_details_database);
  }
  EditTakealotIntegration(client_id: string, enabled: boolean): Promise<Client> {
    return this.clientRepository.EditTakealotIntegration(client_id, enabled);
  }
  EditPersistDriverLocation(client_id: string, enabled: boolean): Promise<Client> {
    return this.clientRepository.EditPersistDriverLocation(client_id, enabled);
  }
  GrantDeliveryMap(client_id: string, delivery_map_enabled: boolean): Promise<Client> {
    return this.clientRepository.GrantDeliveryMap(client_id, delivery_map_enabled);
  }
  GrantAppChatBot(client_id: string, enabled: boolean): Promise<Client> {
    return this.clientRepository.GrantAppChatBot(client_id, enabled);
  }
  UpdateSmsProvider(
    client_id: string,
    sms_provider: string,
    apiKey1?: string,
    apiKey2?: string
  ): Promise<Client> {
    return this.clientRepository.UpdateSmsProvider(client_id, sms_provider, apiKey1, apiKey2);
  }
  GrantFlightboardAccess(client_id: string, enabled: boolean): Promise<Client> {
    return this.clientRepository.GrantFlightboardAccess(client_id, enabled);
  }

  EditRouteOptimization(client_id: string, return_geometry: boolean): Promise<Client> {
    return this.clientRepository.EditRouteOptimization(client_id, return_geometry);
  }

  EnableHubLevelClustering(client_id: string): Promise<Client> {
    return this.clientRepository.EnableHubLevelClustering(client_id);
  }

  DisableHubLevelClustering(client_id: string): Promise<Client> {
    return this.clientRepository.DisableHubLevelClustering(client_id);
  }
}
